import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Navbar from './Navbar';
import Footer from './Footer';

const QueEsPrinconserPage: React.FC = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();

    const t = (es: string, en: string) => language === 'es' ? es : en;

    const sections = [
        {
            id: 'filosofia',
            icon: '🧠',
            title: t('Filosofía Princonser', 'Princonser Philosophy'),
            description: t('La brújula que transforma el aprendizaje en pasión, propósito y poder personal.', 'The compass that transforms learning into passion, purpose, and personal power.'),
            path: '/filosofia-princonser',
            color: 'from-blue-500 to-purple-600'
        },
        {
            id: 'curriculum',
            icon: '📚',
            title: t('Currículum Holístico', 'Holistic Curriculum'),
            description: t('Desarrollo integral en todas las dimensiones humanas para un crecimiento equilibrado.', 'Integral development in all human dimensions for balanced growth.'),
            path: '/curriculum-holistico',
            color: 'from-green-500 to-teal-600'
        },
        {
            id: 'metodo',
            icon: '🎯',
            title: t('Método de Enseñanza', 'Teaching Method'),
            description: t('Aprende de manera efectiva y significativa con metodologías probadas.', 'Learn effectively and meaningfully with proven methodologies.'),
            path: '/metodos-ensenanza',
            color: 'from-orange-500 to-red-600'
        },
        {
            id: 'gamificacion',
            icon: '🎮',
            title: t('Gamificación', 'Gamification'),
            description: t('Aprende jugando, crece ganando con un sistema de recompensas motivacional.', 'Learn by playing, grow by winning with a motivational reward system.'),
            path: '/innovaciones?section=4',
            color: 'from-purple-500 to-pink-600'
        },
        {
            id: 'ecosistema',
            icon: '🌱',
            title: t('Ecosistema Incentivos', 'Incentive Ecosystem'),
            description: t('Donde cada logro genera valor para todos en una comunidad colaborativa.', 'Where every achievement generates value for everyone in a collaborative community.'),
            path: '/innovaciones?section=5',
            color: 'from-emerald-500 to-cyan-600'
        }
    ];

    const handleThemeChange = (theme: number) => {
        // Navegar a la página del libro correspondiente
        const bookRoutes = {
            2: '/libros/1',
            3: '/libros/2', 
            4: '/libros/3',
            5: '/libros/4',
            6: '/libros/5',
            7: '/libros/6',
            8: '/libros/7',
            9: '/libros/8'
        };
        const route = bookRoutes[theme as keyof typeof bookRoutes];
        if (route) {
            window.location.href = route;
        }
    };

    return (
        <div className="min-h-screen">
            {/* Navbar */}
            <Navbar currentTheme={1} onThemeChange={handleThemeChange} />
            
            {/* Contenido principal */}
            <main className="pt-16">
                {/* Sección con imagen completa */}
                <section className="relative w-full">
                    {/* Imagen como elemento de la sección */}
                    <div className="w-full relative overflow-hidden">
                        <img 
                            src={language === 'es' ? "/images/infosection/NinosArbol.png" : "/images/infosection/Whatif.png"}
                            alt={language === 'es' ? "Niños alrededor del árbol" : "What If Princonser Kids?"}
                            className="w-full h-auto object-cover object-center"
                        />
                        {/* Overlay sutil para mejorar legibilidad */}
                        <div className="absolute inset-0 bg-black/5"></div>
                        {/* Tarjetas posicionadas al pie de la imagen */}
                        <div className="absolute bottom-0 left-0 right-0 z-10 p-4 sm:p-6 lg:p-8">
                            <div className="max-w-4xl mx-auto text-center">
                                <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 sm:p-8 shadow-2xl border border-white/20">
                                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-4 leading-tight">
                                        {t('Princonser Kids es el Sistema de Educación Integral más completo que existe con 5 elementos principales', 'Princonser Kids is the most complete Comprehensive Education System with 5 main elements')}
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default QueEsPrinconserPage; 